var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatementIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1487 0.381229C18.9591 0.140634 18.6697 0.000222868 18.3634 0.00021895L1.00001 -5.39882e-07C0.734793 -3.26018e-06 0.480435 0.105352 0.292896 0.292888C0.105356 0.480425 -1.28929e-06 0.734781 -2.68463e-06 0.999998L-3.38503e-06 27.9529C-3.99765e-06 28.5052 0.447699 28.9529 0.999975 28.9529L24.4091 28.9534C24.6743 28.9535 24.9287 28.8481 25.1163 28.6606C25.3038 28.473 25.4092 28.2187 25.4092 27.9534L25.4091 8.6713C25.4091 8.44673 25.3335 8.22869 25.1945 8.05232L19.1487 0.381229ZM23.4091 9.018L23.4091 26.9534L2 26.9529L2 2.00001L17.8782 2.00021L23.4091 9.018Z",
    fill: "#002CB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.48 12.9C10.21 12.31 9.48 11.7 9.48 10.75C9.48 9.66 10.49 8.9 12.18 8.9C13.96 8.9 14.62 9.75 14.68 11H16.89C16.82 9.28 15.77 7.7 13.68 7.19V5H10.68V7.16C8.74 7.58 7.18 8.84 7.18 10.77C7.18 13.08 9.09 14.23 11.88 14.9C14.38 15.5 14.88 16.38 14.88 17.31C14.88 18 14.39 19.1 12.18 19.1C10.12 19.1 9.31 18.18 9.2 17H7C7.12 19.19 8.76 20.42 10.68 20.83V23H13.68V20.85C15.63 20.48 17.18 19.35 17.18 17.3C17.18 14.46 14.75 13.49 12.48 12.9Z",
    fill: "#002CB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementIcon);
export default __webpack_public_path__ + "static/media/StatementIcon.c16d2dafb8949cc2206bf8330a00543e.svg";
export { ForwardRef as ReactComponent };